import { addListener, createAsyncThunk, createSelector, createSelectorCreator, weakMapMemoize } from '@reduxjs/toolkit';

import type { AppDispatch, AppState } from '@/store/store.ts';

export const addAppListener = addListener.withTypes<AppState, AppDispatch>();
export type AppListener = Parameters<typeof addAppListener>[0];
export type AppListenerEffect = Parameters<typeof addAppListener>[0]['effect'];

export const createAppSelector = createSelector.withTypes<AppState>();

export const createWeakSelector = createSelectorCreator({
  memoize: weakMapMemoize,
  argsMemoize: weakMapMemoize,
});

export const createWeakAppSelector = createWeakSelector.withTypes<AppState>();

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: AppState;
  dispatch: AppDispatch;
}>();
